import isEqual from 'lodash/isEqual';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State, Filters } from '../../../../common/types.tsx';

export type SetFiltersAction = (filters: Filters) => Action<
	State,
	{
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		onFiltersChange: (arg1: Filters) => any;
	}
>;
export const setFilters: SetFiltersAction =
	(filters: Filters) =>
	({ getState, setState }, { onFiltersChange }) => {
		const state = getState();

		if (!isEqual(state, filters)) {
			setState({
				filters,
			});

			onFiltersChange && onFiltersChange(filters);
		}
	};
